/**
 *
 * @param {Object} state
 * @param {String} storeId
 */

 const SET_STORE_ID = (state, storeId) => {
  state.storeId = storeId;
};

/**
 *
 * @param {Object} state
 * @param {String} storeUrlPrefix
 */

 const SET_STORE_URL_PREFIX = (state, storeUrlPrefix) => {
    state.storeUrlPrefix = storeUrlPrefix;
};

/**
 * 
 * Set Current Store View
 */
const SET_CURRENT_STORE_VIEW = (state, storeUrlPrefix) => {

  switch (storeUrlPrefix) {
    case 'be':
      state.currentStoreView.countryName = "Belgique";
      state.currentStoreView.countryCode = "Be";
      state.currentStoreView.storeBaseUrl = process.env.VUE_APP_API_BASE_URL + '/be'
      break;
  
    default:
      state.currentStoreView.countryName = "France";
      state.currentStoreView.countryCode = "Fr";
      state.currentStoreView.storeBaseUrl = process.env.VUE_APP_API_BASE_URL
      break;
  }
}

/**
 * Set all storeView Object
 */
const SET_STORE_VIEWS_OBJECT = (state, storeUrlPrefix) => {
 
  let storeObject = {};
  
  switch (storeUrlPrefix) {
    case 'be':
      storeObject.countryName = "Belgique";
      storeObject.countryCode = "Be";
      storeObject.storeBaseUrl = process.env.VUE_APP_API_BASE_URL + '/be'
      break;
  
    default:
      storeObject.countryName = "France";
      storeObject.countryCode = "Fr";
      storeObject.storeBaseUrl = process.env.VUE_APP_API_BASE_URL
      break;
  }

  state.storeViews.push(storeObject);
}

export default {
  SET_STORE_ID,
  SET_STORE_URL_PREFIX,
  SET_CURRENT_STORE_VIEW,
  SET_STORE_VIEWS_OBJECT
};
